import handleTranslation from '@/helpers/handleTranslation';

export const translatedMDFValues = {
  // Header
  additionalInformation: handleTranslation(
    'Microsoft Tenant & Admin user information',
    'Informações do tenant e do utilizador administrador'
  ),
  additionalInformationDescription: handleTranslation(
    'Please provide the details to create the Microsoft tenant and admin user account',
    'Por favor, forneça os detalhes para criar o tenant e o utilizador administrador da Microsoft'
  ),

  // Labels
  microsoftTenantName: handleTranslation('Microsoft tenant name', 'Nome do tenant da Microsoft'),
  userPrincipleName: handleTranslation('User principle name', 'Nome do user principle'),
  email: handleTranslation('Email', 'E-mail'),
  alternateEmail: handleTranslation('Alternate Email address', 'Endereço de e-mail alternativo'),
  firstName: handleTranslation('First Name', 'Nome'),
  lastName: handleTranslation('Last name', 'Apelido'),
  businessName: handleTranslation('Business Name', 'Nome da empresa'),
  address: handleTranslation('Address', 'Morada'),
  address2: handleTranslation('Address 2', 'Continuação da morada'),
  zipCode: handleTranslation('ZipCode', 'Código postal'),
  city: handleTranslation('City', 'Cidade'),
  country: handleTranslation('Country', 'País'),
  county: handleTranslation('County', 'Condado'),
  phoneNumber: handleTranslation('Phone Number', 'Número de telefone'),
  organizationRegistrationNumber: handleTranslation(
    'Organization registration number',
    'Número de registro da organização'
  ),
  consentUserFirstName: handleTranslation('Consent User - First name', 'Usuário de consentimento - Primeiro nome'),
  consentUserLastName: handleTranslation('Consent User - Last name', 'Usuário de consentimento - Sobrenome'),
  consentUserEmail: handleTranslation('Consent User - Email', 'Usuário de consentimento - E-mail'),
  consentUserPhone: handleTranslation('Consent User - Phone Number', 'Usuário de consentimento - Número de telefone'),

  // Placeholders
  tenantNamePlaceholder: handleTranslation('tenantName', 'Nome do tenant'),
  usernamePlaceholder: handleTranslation('username', 'Username'),
  emailPlaceholder: handleTranslation('email', 'Endereço de e-mail'),
  alternateEmailPlaceholder: handleTranslation('alternate Email', 'E-mail alternativo'),
  firstNamePlaceholder: handleTranslation('firstName', 'Nome'),
  lastNamePlaceholder: handleTranslation('lastName', 'Apelido'),
  businessNamePlaceholder: handleTranslation('Your Business Name', 'Nome da empresa'),
  addressPlaceholder: handleTranslation('Your address', 'Morada'),
  address2Placeholder: handleTranslation('Your other address', 'Continuação da morada'),
  zipCodePlaceholder: handleTranslation('zipCode', 'Código postal'),
  cityPlaceholder: handleTranslation('city', 'Cidade'),
  phoneNumberPlaceholder: handleTranslation('Phone Number', 'Número de telefone'),
  orgNumberPlaceholder: handleTranslation('Organization registration number', 'Número de registo da organização'),
  consentFirstNamePlaceholder: handleTranslation('consentFirstName', 'Nome'),
  consentLastNamePlaceholder: handleTranslation('consentLastName', 'Apelido'),
  consentEmailPlaceholder: handleTranslation('Consent User Email', 'Endereço de e-mail'),
  consentPhonePlaceholder: handleTranslation('Consent User Phone Number', 'Número de telefone'),

  // Error Messages
  nameIncorrect: handleTranslation(
    'The name is incorrect. Please try again',
    'O nome está incorreto. Por favor, tente novamente'
  ),
  usernameIncorrect: handleTranslation(
    'The Username is incorrect. Please try again',
    'O nome de utilizador está incorreto. Por favor, tente novamente'
  ),
  emailInvalid: handleTranslation(
    'Please enter a valid email address and does not have @Microsoft.com in it',
    'Por favor, insira um endereço de e-mail válido e que não contenha @Microsoft.com'
  ),
  altEmailIncorrect: handleTranslation(
    'The Alternate Email is incorrect. Please try again',
    'O e-mail alternativo está incorreto. Por favor, tente novamente'
  ),
  firstNameIncorrect: handleTranslation(
    'The First name is incorrect. Please try again',
    'O primeiro nome está incorreto. Por favor, tente novamente'
  ),
  lastNameIncorrect: handleTranslation(
    'The Last name is incorrect. Please try again',
    'O sobrenome está incorreto. Por favor, tente novamente'
  ),
  businessNameIncorrect: handleTranslation(
    'The Business name is incorrect. Please try again',
    'O nome da empresa está incorreto. Por favor, tente novamente'
  ),
  addressIncorrect: handleTranslation(
    'The address is incorrect. Please try again',
    'O endereço está incorreto. Por favor, tente novamente'
  ),
  zipCodeIncorrect: handleTranslation(
    'The ZipCode is incorrect. Please try again',
    'O código postal está incorreto. Por favor, tente novamente'
  ),
  cityIncorrect: handleTranslation(
    'The City is incorrect. Please try again',
    'A cidade está incorreta. Por favor, tente novamente'
  ),
  chooseCountry: handleTranslation('Please choose a Country', 'Por favor, escolha um país'),
  chooseCounty: handleTranslation('Please choose a County', 'Por favor, escolha um condado'),
  phoneInvalid: handleTranslation(
    'Please enter a valid phone number (numbers only)',
    'Por favor, insira um número de telefone válido (apenas números)'
  ),
  orgNumberIncorrect: handleTranslation(
    'The Organization registration number is incorrect. Please try again',
    'O número de registo da organização está incorreto. Por favor, tente novamente'
  ),
  fillField: handleTranslation('Please fill this field', 'Por favor, preencha este campo'),

  // Info Messages
  tenantNameInfo: handleTranslation(
    'You can find your tenant name on your Microsoft portal profile.',
    'Pode encontrar o nome do tenant no perfil do portal da Microsoft.'
  ),
  accessTenantName: handleTranslation(
    'Access your tenant name by clicking here',
    'Acesse o nome do tenant clicando aqui'
  ),

  // Select Options
  selectCountry: handleTranslation('Select Country', 'Selecione o país'),
  selectCounty: handleTranslation('Select County', 'Selecione o condado'),
  loadingCounties: handleTranslation('Loading counties...', 'A carregar condados...'),

  // Buttons
  cancel: handleTranslation('Cancel', 'Cancelar'),
  saveDetails: handleTranslation('Save Details', 'Guardar detalhes'),

  // Info Messages
  missingOrIncorrectInformation: handleTranslation(
    'There is missing or incorrect information',
    'Existe informação em falta ou incorreta.'
  ),

  // MCA State Notification
  mcaStateHeading: handleTranslation(
    'Microsoft requires additional information',
    'A Microsoft requer informações adicionais'
  ),
  mcaStateDescription: handleTranslation(
    'Accept the Microsoft Customer Agreement to proceed',
    'Aceite o Contrato de Cliente da Microsoft para prosseguir'
  ),
};
